import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { concat } from 'rxjs';
import { map, toArray } from 'rxjs/operators';
import { Direction, DocumentConfig, DocumentConfigSearchDisplay } from '../models';
import { JsonHttpService } from '../../shared/http/json-http.service';

export class DocumentConfigSearch {
    distributionObjectId: number = null;

    constructor(public direction: Direction) { }
}

@Injectable({
    providedIn: 'root'
})
export class DocumentConfigService {
    constructor(private httpService: JsonHttpService) { }

    getDocumentConfig(documentConfigId: number): Promise<DocumentConfig> {
        const options = { params: new HttpParams().set('documentConfigId', `${documentConfigId}`) };
        return this.httpService.get('/api/distribution/documentconfig/get-document-config', options).toPromise();
    }

    getDocumentConfigs(documentConfigSearch: DocumentConfigSearch): Promise<DocumentConfigSearchDisplay[]> {
        if (documentConfigSearch.direction) {
            const options = { params: new HttpParams().set('direction', `${documentConfigSearch.direction.toString()}`) };
            if (documentConfigSearch.distributionObjectId) {
                options.params = options.params.set('distributionObjectId', `${documentConfigSearch.distributionObjectId}`);
            }
            return this.httpService.get('/api/distribution/documentconfig/get-document-config-search', options).toPromise();
        }
        else {
            const optionsIn = { params: new HttpParams().set('direction', 'In') };
            const optionsOut = { params: new HttpParams().set('direction', 'Out') };
            if (documentConfigSearch.distributionObjectId) {
                optionsIn.params = optionsIn.params.set('distributionObjectId', `${documentConfigSearch.distributionObjectId}`);
                optionsOut.params = optionsOut.params.set('distributionObjectId', `${documentConfigSearch.distributionObjectId}`);
            }
            const combined = concat(
                this.httpService.getTyped<DocumentConfigSearchDisplay[]>('/api/distribution/documentconfig/get-document-config-search', optionsIn),
                this.httpService.getTyped<DocumentConfigSearchDisplay[]>('/api/distribution/documentconfig/get-document-config-search', optionsOut)
            ).pipe(
                toArray(),
                map(arrays => arrays.flat()),
                map(allItems => {
                    // After flattening the array of arrays, duplicates are removed by creating a Map from the items,
                    // keyed by a unique property (DocumentConfigId in this case). Since a Map automatically overwrites
                    // previous entries with the same key, this effectively removes duplicates.
                    const uniqueItems = Array.from(new Map(allItems.map(item => [item.DocumentConfigId, item])).values());
                    return uniqueItems;
                })
            );
            return combined.toPromise();
        }
    }
}
